import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { containerReducer } from './container.reducer';
import {
  STATE_FEATURE_CONTAINER,
  getInitialContainerState,
} from './container.state';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_FEATURE_CONTAINER, containerReducer, {
      initialState: getInitialContainerState,
    }),
  ],
  providers: [],
})
export class ContainerStateModule {}
